import { pastelStyle } from '../theme/cssVars';

/**
 * Ported from src/components/ui/IdentityChip.tsx. The colour comes from the app's own
 * deterministic pastelFor(name), so a project keeps the same mark on both clients.
 */
export default function IdentityChip({ name, size = 40 }: { name: string; size?: number }) {
  const { background, color } = pastelStyle(name);
  return (
    <span
      data-identity
      className="identity-chip"
      style={{
        width: size,
        height: size,
        borderRadius: size < 44 ? 12 : 16,
        background,
        color,
        fontSize: Math.round(size * 0.45),
      }}
    >
      {(name.trim()[0] ?? '?').toUpperCase()}
    </span>
  );
}
